import parse from 'html-react-parser';

const RawHtml = ({content}) => {
    return parse(content);
};

export default RawHtml;
